import styled from '@emotion/styled';
import { Column } from '@dh/styles';
import { shouldForwardProps } from '@dh/utils';

const StyledHint = styled(Column, shouldForwardProps)`
    background-color: ${({ theme }) => theme.colors.primaryContainer};
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
    border: ${({ theme }) => `2px solid ${theme.colors.primary60}`};
`;

export { StyledHint };
